import { doGuides, donGuides } from "@/mocks/editorial";
import SectionHeader from "./SectionHeader";

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-24 bg-background-100 py-12 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeader
          align="center"
          kicker="理性吃瓜 · 实践指南"
          title="热闹里，如何保持清醒"
          desc="吃瓜本身没有错，真正的问题在于被情绪推着走。把下面两条清单当成自己的“冷静阀”，热度越高，越值得先过一遍。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {/* 应该做 */}
          <div className="rounded-2xl border border-primary-200 bg-background-50 p-6 md:p-7">
            <div className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-check-line"></i>
              </span>
              <h3 className="font-heading text-xl font-semibold text-foreground-950">
                理性吃瓜 · 应该做
              </h3>
            </div>
            <ul className="mt-6 space-y-4">
              {doGuides.map((g) => (
                <li key={g.title} className="flex gap-3">
                  <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-primary-100 text-primary-700">
                    <i className={`${g.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="font-medium text-foreground-900">{g.title}</h4>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                      {g.body}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* 避免 */}
          <div className="rounded-2xl border border-foreground-900/10 bg-foreground-950 p-6 text-background-50 md:p-7">
            <div className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-close-line"></i>
              </span>
              <h3 className="font-heading text-xl font-semibold">理性吃瓜 · 要避免</h3>
            </div>
            <ul className="mt-6 space-y-4">
              {donGuides.map((g) => (
                <li key={g.title} className="flex gap-3">
                  <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-background-100/10 text-accent-300">
                    <i className={`${g.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="font-medium">{g.title}</h4>
                    <p className="mt-1 text-sm leading-relaxed text-background-200/90">
                      {g.body}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}